"use client";
import {
  UsersRound,
  Laptop,
  UserRound,
  BriefcaseBusiness,
} from "lucide-react";

const problems = [
  {
    percentage: "4.4%",
    text: "Of India’s working-age population (15–59 years) has received formal vocational training.",
    icon: UsersRound,
  },
  {
    percentage: "30.6%",
    text: "Have undergone training outside formal systems, including 7.1% who are self-taught and 9.3% who acquired skills through on-the-job learning.",
    icon: Laptop,
  },
  {
    percentage: "65.3%",
    text: "Have not received any form of vocational or technical training.",
    icon: UserRound,
  },
  {
    percentage: "53%",
    text: "Of graduates, along with 36% of postgraduates are employed in roles below their level of qualification.",
    icon: BriefcaseBusiness,
  },
];

export default function ProblemsWeSolve() {
  return (
    <section className="max-w-[var(--max-page-width)] px-[var(--container-padding)]">
      <div className="mx-auto w-full">
        <h2
          className="mb-4 text-2xl font-saans-bold font-semibold text-white sm:text-3xl lg:text-[42px]"
          style={{ fontFamily: "saans-bold" }}
        >
          Problems We Solve
        </h2>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-11 lg:grid-cols-4 lg:gap-7 xl:gap-8">
          {problems.map((problem) => {
            const Icon = problem.icon;

            return (
              <div
                key={problem.percentage}
                className="group flex min-h-90 flex-col rounded-sm bg-white p-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl sm:p-7 md:min-h-92.5 lg:p-6 xl:min-h-[385px] xl:p-7"
              >
                <div className="flex h-15 w-15 shrink-0 items-center justify-center rounded-full"
                  style={{
                    background: "#087db2",
                  }}>
                  <Icon
                    size={30}
                    strokeWidth={1.7}
                    className="text-white"
                  />
                </div>

                <h3 className="mt-8 text-2xl md:text-4xl font-bold leading-none tracking-tight text-[#171d2b] ">
                  {problem.percentage}
                </h3>

                <p className="mt-6 max-w-85 text-[18px] leading-[1.7] text-[#182b42] sm:text-[18px]">
                  {problem.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}